<template>
	<div>
		<span>{{ item.data.postal_code ? `${item.data.postal_code},` : '' }} {{ `${item.value}` }}</span>
	</div>
</template>

<script>
export default {
	props: {
		item: { type: Object, required: true },
	},
};
</script>
